import { TRANSCRIPT_SERVICE_URL } from 'config';

export const TRANSCRIPT_EXPORT_V1_URL = `${TRANSCRIPT_SERVICE_URL}/api/v1/transcript/eddy/project`;
